/**
 * Handle App's Local or ServerSync Objects, Vars Initializations
 * Handle TextZoom
 * Serverstatus check
 */

import { AppContext, ExAppContext } from '../Context';
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { Fragment, useContext, useState, useRef, useEffect } from 'react';
import { isPlatform } from '@ionic/react';
import { TextZoom } from '@capacitor/text-zoom';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { setupIonicReact } from '@ionic/react';
import { DebugLogger as dlog } from '../components/Logger'
import { Device } from '@capacitor/device';

//classes
import Member from '../classes/member';

//controllers
import DatabaseInterfaceController from './DatabaseInterfaceController';

const AppController = () => {
    //context
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    // //states
    // const [initializeFetchSequence, SetInitializeFetchSequence] = useState(-1);
    const [initializeGetSequence, SetInitializeGetSequence] = useState(-1);
    const [serverStatus, SetServerStatus] = useState(true);
    // //refs
    // const initializeFetchSequenceRef = useRef(-1);
    const initializeGetSequenceRef = useRef(-1);
    const userRef = useRef<Member>({} as Member);
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    const screenResizeHandlerRef = useRef(() => {
        let deviceOrientation = System_DeviceOrientationMap.PORTRAIT;
        if(window.innerWidth > window.innerHeight)
            deviceOrientation = System_DeviceOrientationMap.LANDSCAPE;
        appContext.SetDeviceOrientation(deviceOrientation);
    });

    //watcher
    //test
    // useEffect(() => {
    //     console.log('AppControllerTest:' + JSON.stringify(exAppContext.events));
    // }, [exAppContext.events]);

    //override phone's system text manigfication
    useEffect(() => {
        //set textzoom on app start
        if (isPlatform('hybrid')) {
            //stop all default back button behavior
            setupIonicReact({
                hardwareBackButton: false
            });
            TextZoom.set({ value: 1 });
        }

        //set app safe area
        const SetSafeArea =  async() => {
            const safeAreaData = await SafeArea.getSafeAreaInsets();
            const {insets} = safeAreaData;
            // if(isPlatform('android')) {
            //     appContext.SetSafeArea({"top":0,"left":0,"right":0,"bottom":0});
            // } else {
            //     appContext.SetSafeArea(insets);
            // }
            const info = await Device.getInfo();
            const deviceOsVersion = parseInt(info.osVersion || '0', 10);
            if(isPlatform('android') && deviceOsVersion < 13) {
                appContext.SetSafeArea({"top":0,"left":0,"right":0,"bottom":0});
                document.documentElement.style.setProperty('--safe-area-inset-bottom', '0px');
            } else {
                appContext.SetSafeArea(insets);
            }
            dlog('checkinsets: ' + JSON.stringify(insets));
        };

        //device orientation
        screenResizeHandlerRef.current();
        window.addEventListener('resize', screenResizeHandlerRef.current);

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    SetSafeArea();
                });
            });
        });

        CheckServerStatus();

    }, []);

    //watch for appStateChangesWatch
    useEffect(() => {
        //notes: to use default's listeners behavior, set {key: null},
        //       to not allow default or any other behavior, set {key: () => {}}, or turn appStateChangeWatch to false
        App.removeAllListeners();
        if (appContext.appStateChangeWatch == true) {
            appContext.appListenerActions.map((listenerMap: string) => {
                const listenerKey = listenerMap[0];
                const listenerAction: any = listenerMap[1];
                switch (listenerKey) {
                    case 'backButton':
                        App.addListener('backButton', ({ canGoBack }) => {
                            if (listenerAction != null) {
                                console.log('listenerActionNotNull!');
                                // appContext.routeControlHistoryStayAction(); ---deprecated
                                listenerAction();
                            }
                            else {
                                console.log('checkRoute: ' + JSON.stringify(appContext.routeControlHistoryStacks));
                                //default backbutton press behavior
                                console.log('checkRoute:shouldFireRouteControlHistoryBackAction!');
                                if(location.pathname != '/Splash' && location.pathname != '/')
                                    appContext.routeControlHistoryBackAction(appContext.routeControlHistoryStacks);
                                else
                                    App.exitApp();

                            }
                        });
                        break;
                    case 'appStateChange':
                        App.addListener('appStateChange', ({ isActive }) => {
                            if (listenerAction != null)
                                listenerAction();
                            else {
                                // if (!isActive)
                                //     isPlatform('hybrid') ? App.exitApp() : null; ---disable appStateChangeWatch exit app
                            }
                        });
                        break;
                    //deeplinking
                    case 'appUrlOpen':
                        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
                            if (listenerAction != null)
                                listenerAction();
                            else {
                                console.log('app opened by deeplink');
                            }
                        });
                        break;
                }
            });
        } else {
            //on app resume turn appStateChangeWatch back on
            App.addListener('appStateChange', ({ isActive }) => {
                if(isActive) {
                    appContext.SetAppStateChangeWatch(true);
                }
            });
        }
    }, [appContext.appStateChangeWatch, appContext.appListenerActions]);

    //watch for databaseResultActions
    useEffect(() => {
        if (appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                if (!JSON.stringify(res).includes('false')) {

                } else {
                    console.log(mode + 'Err: ' + JSON.stringify(res));

                    if(mode == 'checkServerStatus') {
                        //server down
                        appContext.SetWaitScreenMessage('Server is currently under maintenance, please try again later');
                        appContext.SetWaitScreenShouldShow(true);
                    }
                }
            }

            switch (appContext.databaseActionModeQueue[0]) {
                case 'checkServerStatus':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseResultAction, appContext.databaseActionModeQueue]);

    //watch for initialize local database get
    useEffect(() => {
        switch (initializeGetSequence) {
            case 0:
                break;
        }
    }, [initializeGetSequence]);
    useEffect(() => {
        if (appContext.storageRequestResultAction != null && appContext.storageRequestMode != null) {

        }
    }, [appContext.storageRequestResultAction, appContext.storageRequestMode]);

    //exe function
    const CheckServerStatus = () => {
        databaseInterfaceController.Queue('checkServerStatus', [
            ['checkServerStatus', 'true']
        ]);
    };

    return (<Fragment></Fragment>);
}
export default AppController;